import styled from "styled-components"

const StyledFigure = styled.figure`
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 350px;
  img {
    object-fit: contain;
    &:-moz-broken {
      opacity: 0;
    }
  }
  a {
    display: flex;
    justify-content: center;
  }
`

export default StyledFigure
